<template>
  <div class="AppBulkList">
    <AppBulkListItem @click="toggleSummary" class="clickable">
      <span>{{ displayedToggleLabel }}</span>
      <app-badge variant="info" size="small">{{ itemsCount }}</app-badge>
      <app-icon-ds
        :icon="isOpened ? 'chevron-up' : 'chevron-down'"
        class="ml-auto"
        size="xxs"
      />
    </AppBulkListItem>
    <transition-group name="app-fade">
    <template v-if="isOpened">
      <div class="AppBulkList__items-wrapper">
        <AppBulkListItem v-for="(item, index) in items" :key="index">
          <slot :item="item">{{ item }}</slot>
        </AppBulkListItem>
      </div>
    </template>
    </transition-group>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AppBulkListItem from '@/common/app-bulk-list/AppBulkListItem.vue'

export default defineComponent({
  name: 'AppBulkList',
  components: {
    AppBulkListItem,
  },
  props: {
    items: {
      type: Array as PropType<Array<any>>,
      required: false,
      default: () => [],
    },
    itemsName: {
      type: String,
      required: false,
      default: 'common.app-bulk-list.defaultItemsName',
    },
  },
  data () {
    return {
      isOpened: false,
    }
  },
  computed: {
    displayedToggleLabel (): string {
      return this.$t(
        this.isOpened
          ? 'common.app-bulk-list.toggleLabel.hide'
          : 'common.app-bulk-list.toggleLabel.show',
        { itemsName: this.itemsName },
      ) as string
    },
    itemsCount (): number {
      return this.items.length
    },
  },
  methods: {
    toggleSummary () {
      this.isOpened = !this.isOpened
    },
  },
})
</script>
<style lang="scss" scoped>
.AppBulkList {
  &__items-wrapper {
    margin-top: 16px;
    max-height: 260px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>